import { ReactElement } from 'react'
import { useMappingPlatforms } from 'app/components/mapping-platforms/useMappingPlatforms'
import { MappingPlatformsShadcnComponent } from 'app/components/mapping-platforms/MappingPlatformsShadcnComponent'

export default function Platform(): ReactElement {
  const { groupedPlatforms, platformNames, loading, canEditMapping, onAdd, onEdit, onDelete, isDefaultMapping } =
    useMappingPlatforms()

  return (
    <MappingPlatformsShadcnComponent
      groupedPlatforms={groupedPlatforms}
      platformNames={platformNames}
      loading={loading}
      canEditMapping={canEditMapping}
      onAdd={onAdd}
      onEdit={onEdit}
      onDelete={onDelete}
      isDefaultMapping={isDefaultMapping}
    />
  )
}
